import { Deposito } from "../../../actividades/entity-depositos/depositos.model"
import { Laboratorio } from "../../../actividades/entity-laboratorios/laboratorios.model"
import { MaquinaMovil } from "../../../actividades/entity-maquinas-moviles/entity-maquinas-moviles.model"
import { SitioProcesamiento } from "../../../actividades/entity-sitios-procesamiento/sitios-procesamiento.model"
import { ViveroFormInput } from "../../../actividades/entity-viveros-grupo-especie/models/entity-viveros-grupo-especie.models"
import { EntidadesProductiva } from "../../entity-entidad-productiva/entity-entidades-productiva.model"

export interface VistaMisDepositosDependenciasInput {
  entidadProductiva: EntidadesProductiva[]
  formInputViveros: ViveroFormInput[]
  laboratorios: Laboratorio[]
  sitiosProcesamiento: SitioProcesamiento[]
  depositos: Deposito[]
  maquinasMoviles: MaquinaMovil[]
}

export const createVistaDepositosDependencias = (): VistaMisDepositosDependenciasInput => {
  return {
    entidadProductiva: null,
    formInputViveros: null,
    laboratorios: null,
    sitiosProcesamiento: null,
    depositos: null,
    maquinasMoviles: null
  }
}
